import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { signOutAction } from '../actions'

export type WorkOrderSearchState = {
  phrase: string
}

export const initialState: WorkOrderSearchState = {
  phrase: '',
}

const WorkOrderSearchSlice = createSlice({
  extraReducers: builder => {
    builder.addCase(signOutAction, state => {
      state.phrase = initialState.phrase
    })
  },
  initialState,
  name: 'workOrderSearch',
  reducers: {
    setPhrase(state, action: PayloadAction<string>) {
      state.phrase = action.payload
    },
    clearPhrase(state) {
      state.phrase = ''
    },
  },
})

export const WorkOrderSearchReducer = WorkOrderSearchSlice.reducer

export const WorkOrderSearchActions = WorkOrderSearchSlice.actions
